import { request } from "@/utils/request";
export function policy() {
  return request("get", "/aliyun/oss/policy");
}



// WEBPACK FOOTER //
// ./src/api/oss.js